import { Link } from "wouter";
import { Logo } from "../lib/brand";

const cols = [
  { h: "For Job Seekers", items: ["Browse Jobs", "Post Résumé", "How It Works", "Career Resources"] },
  { h: "For Professionals", items: ["Browse Services", "List a Service", "Tips & Guides", "Help Center"] },
  { h: "For Companies", items: ["Post a Job", "Company Profiles", "Service Requests", "Projects & Bidding"] },
  { h: "About KontrataPH", items: ["About Us", "Our Mission", "Blog", "Terms of Service", "Privacy Policy"] },
];

// Every footer label maps to a real destination (no dead links).
const LINKS: Record<string, string> = {
  // For Job Seekers
  "Browse Jobs": "/marketplace?tab=Jobs",
  "Post Résumé": "/post/resume",
  "How It Works": "/how-it-works",
  "Career Resources": "/how-it-works",
  // For Professionals
  "Browse Services": "/marketplace?tab=Services",
  "List a Service": "/post/service",
  "Tips & Guides": "/how-it-works",
  "Help Center": "/support",
  // For Companies
  "Post a Job": "/post/job",
  "Company Profiles": "/marketplace?tab=Companies",
  "Service Requests": "/marketplace?tab=RFQs",
  "Projects & Bidding": "/marketplace?tab=Projects",
  // About
  "About Us": "/how-it-works",
  "Our Mission": "/how-it-works",
  "Blog": "/how-it-works",
  "Terms of Service": "/legal/terms",
  "Privacy Policy": "/legal/privacy",
};

export function Footer() {
  return (
    <footer className="bg-navy text-white/80 mt-8">
      <div className="container-x py-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-1">
          <Logo light withTagline />
          <p className="text-sm text-white/60 mt-3 max-w-xs">
            The open Filipino marketplace for work, services, projects, and contracts.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.h}>
            <h4 className="text-white font-bold text-sm mb-3">{c.h}</h4>
            <ul className="space-y-2 text-sm">
              {c.items.map((i) => (
                <li key={i}><Link href={LINKS[i] || "/marketplace"} className="hover:text-white">{i}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© 2026 KontrataPH. All rights reserved.</span>
          <span>Trabaho. Serbisyo. Negosyo. Kontrata.</span>
        </div>
      </div>
    </footer>
  );
}
